<template>
  <section>
    <section v-if="type==2">
      <h2 v-if="productId!=13">Quick Quote Detail</h2>
      <quick-quote-info
        v-if="productId!=13&&productId!=80"
        :productId="productId"
        :quoteForm="form"></quick-quote-info>
      <sme-qucik-info
        v-if="productId==80"
        :form-data="referData"
        :sme-class-id="referData.class_id"></sme-qucik-info>
      <h2>Policy Detail</h2>
      <housemaid-quote-info
        v-if="productId == 12"
        :title="false"
        :formData="form" />
      <decoration-quote-info
        v-else-if="productId == 15"
        :title="false"
        :formData="form" />
      <travel-quote-info
        v-else-if="productId == 14"
        :title="false"
        :formData="form" />
      <homefire-quote-info
        v-else-if="productId == 17"
        :title="false"
        :formData="form" />
      <personal-quote-info
        v-else-if="productId == 18"
        :title="false"
        :formData="form" />
      <student-quote-info
        v-else-if="productId == 16"
        :title="false"
        :formData="form" >
      </student-quote-info>
      <working-quote-info
        v-else-if="productId == 13"
        :title="false"
        :formData="form">
      </working-quote-info >
      <fire-quote-info
        v-else-if="productId == 20"
        :title="false"
        :formData="form" />
      <template v-else-if="productId==80">
        <sme-kyc-info
          :form-data="referData"
          :class-id="referData.class_id"></sme-kyc-info>
      </template>
      <template v-else>
        <div class="table strip">
          <div class="tr">
            <span>Expected Effective Date</span>
            <span v-copy="`${form.period_start} - ${form.period_end}`">
              {{ form.period_start }} - {{ form.period_end }}
              <span
                v-if="form.is_eff_dt_delay"
                class="asap">(ASAP)</span>
            </span>
          </div>
          <div class="tr">
            <span>Insurance Type</span>
            <span v-copy="form.product_language">{{ form.product_language }}</span>
          </div>
          <div
            v-if="form.trm_of_cvr != 1"
            class="tr">
            <span>Sum Insured</span>
            <span v-copy="form.isrd_vl">{{ form.isrd_vl }}</span>
          </div>
          <div
            v-if="form.trm_of_cvr != 1"
            class="tr">
            <span>Hire Purchase Owner</span>
            <span v-copy="getOptionName('yesNoOptions', form.hp_ind)">{{getOptionName('yesNoOptions', form.hp_ind)  }}</span>
          </div>
          <div
            v-if="form.trm_of_cvr != 1 && form.hp_ind == 1"
            class="tr">
            <span>Name of Hire Purchase Owner (If Yes for Hire purchase)</span>
            <span
              v-if="!isMortgagorOther"
              v-copy="getLocalAllOptionName('mortgagor', form.mortgagor)">{{ getLocalAllOptionName('mortgagor', form.mortgagor)}}</span>
            <span
              v-else
              v-copy="form.mortgagor_other">{{  form.mortgagor_other}}</span>
          </div>
          <div class="tr">
            <span>More Benefits</span>
            <span
              v-if="benefits.length > 0"
              class="child-span-block">
              <span
                v-for="(item, index) in benefits"
                :key="index"
                v-copy="item.name"
                class="red">
                {{ item.name }}
              </span>
            </span>
            <span v-else>None</span>
          </div>
          <div
            v-if="form.class_id==11&&extraBenefitSelect.length>0"
            class="tr">
            <span>Extra Benefits</span>
            <span>
              <span
                v-for="(item,index) in extraBenefitSelect"
                :key="'extra'+index"
                v-copy="item.name">{{item.name}}<br></span>
            </span>
          </div>
        </div>
        <!--        <h2>Insured Vehicle</h2>-->
        <h2 v-if="form.class_id == 14">Insured Motorcycle Details</h2>
        <h2 v-if="form.class_id == 11">Insured Private Details</h2>
        <h2 v-if="form.class_id == 12">Insured Commercial Vehicle Details</h2>

        <insured-vehicle-info :form="form" />
        <h2>Policyholder Details</h2>
        <policy-holder-info :form="form" />
        <h2>Named Driver Information</h2>
        <drivers-info :form="form" />
      </template>
    </section>
    <template v-else-if="type === 5">
      <h2>Request Detail</h2>
      <div class="table strip">
        <div class="tr">
          <span>Type</span>
          <span>{{ insuranceType }}</span>
        </div>
      </div>
      <div class="table">
        <div class="tr">
          <span>Name</span>
          <span>{{ form.name }}</span>
        </div>
        <div class="tr">
          <span>Phone No.</span>
          <span>{{ form.phone }}</span>
        </div>
        <div class="tr">
          <span>Email</span>
          <span>{{ form.email }}</span>
        </div>
        <div class="tr">
          <span>Referral Code</span>
          <span>{{ form.promo_code }}</span>
        </div>
        <div class="tr">
          <span>Coupon Code</span>
          <span>{{ form.coupon_code }}</span>
        </div>
        <div class="tr">
          <span>Renewal Notice</span>
          <span
            v-if="form.renewal_notice&&form.renewal_notice.url"
            class="blue pointer"
            @click="openFile(form.renewal_notice.url?form.renewal_notice.url:null)">{{ form.renewal_notice? form.renewal_notice.client_name: '' }}</span>
        </div>

        <industry-info
          v-if="isIndustry"
          :form="form" />
        <!-- Business Package -->
        <section v-if="form.insurance_type === 1001">
          <div class="tr">
            <span>Insured Name </span>
            <span>{{ form.isrd_nm }}</span>
          </div>
          <div class="tr">
            <span>Effective Date </span>
            <span>{{ form.eff_dt }}</span>
          </div>
          <div class="tr">
            <span>Business Nature </span>
            <span>
              {{ getGlobalOptionName('industry', form.business) }}
            </span>
          </div>
          <div class="tr">
            <span>Sum Insured - Building </span>
            <span>{{ form.sum_building | formatMoney }} HK$</span>
          </div>
          <div class="tr">
            <span>Sum Insured - Contents </span>
            <span>{{ form.sum_content | formatMoney }} HK$</span>
          </div>
          <div class="tr">
            <span>Sum Insured - Stock</span>
            <span>{{ form.sum_stock | formatMoney }} HK$</span>
          </div>
          <div class="tr">
            <span>No. of Employee(s)</span>
            <span>{{ form.no_of_employee }} Person</span>
          </div>
          <div class="tr">
            <span>Have you made or reported claim in the last 3 years?</span>
            <!-- <v-input v-model="formData.claim_ind" /> -->
            <span>{{ getOptionName('yesNo2Options', form.claim_ind) | formatYesNo }}</span>
          </div>
          <div class="tr">
            <span>Do you have any existing policy schedule(s)?</span>
            <span>{{ getOptionName('yesNo2Options', form.pcy_sch_ind) | formatYesNo }}</span>
          </div>
          <span class="address-label">Insured Premises Address</span>
          <div class="tr">
            <span>Room</span>
            <span>{{ form.addr_room }}</span>
          </div>
          <div class="tr">
            <span>Floor</span>
            <span>{{ form.addr_floor }}</span>
          </div>
          <div class="tr">
            <span>Block</span>
            <span>{{ form.addr_block }}</span>
          </div>
          <div class="tr">
            <span>Building / Estate</span>
            <span>{{ form.addr_building }}</span>
          </div>
          <div class="tr">
            <span>Street</span>
            <span>{{ form.addr_street }}</span>
          </div>
          <div class="tr">
            <span>District</span>
            <span>{{ getAreaName('district', form.addr_district) }}</span>
          </div>
          <div class="tr">
            <span>Area</span>
            <span>{{ getAreaName('area', form.addr_area) }}</span>
          </div>
          <div class="tr">
            <span>Country / Region</span>
            <span>{{ getAreaName('region', form.addr_region) }}</span>
          </div>
        </section>
        <!-- Employee Compensation (E.C.) -->
        <section v-if="form.insurance_type === 1101">
          <div class="tr">
            <span>Insured Name </span>
            <span>{{ form.isrd_nm }}</span>
          </div>
          <div class="tr">
            <span>Effective Date </span>
            <span>{{ form.eff_dt }}</span>
          </div>
          <div class="tr">
            <span>Business Nature </span>
            <span>
              {{ getGlobalOptionName('industry', form.business) }}
            </span>
          </div>
          <div class="tr">
            <span>No. of Employee(s)</span>
            <span>{{ form.no_of_employee }} Person</span>
          </div>
          <div class="tr">
            <span>Work oversea?</span>
            <span>{{ getOptionName('yesNo2Options', form.oversea_ind) | formatYesNo }}</span>
          </div>
          <div class="tr">
            <span>Have you made or reported a claim in the last 3 years?</span>
            <span>{{ getOptionName('yesNo2Options', form.claim_ind) | formatYesNo }}</span>
          </div>
          <div class="tr">
            <span>Do you have any existing policy schedule(s)?</span>
            <span>{{ getOptionName('yesNo2Options', form.pcy_sch_ind) | formatYesNo }}</span>
          </div>
          <span class="address-label">Insured Premises Address</span>
          <div class="tr">
            <span>Room</span>
            <span>{{ form.addr_room }}</span>
          </div>
          <div class="tr">
            <span>Floor</span>
            <span>{{ form.addr_floor }}</span>
          </div>
          <div class="tr">
            <span>Block</span>
            <span>{{ form.addr_block }}</span>
          </div>
          <div class="tr">
            <span>Building / Estate</span>
            <span>{{ form.addr_building }}</span>
          </div>
          <div class="tr">
            <span>Street</span>
            <span>{{ form.addr_street }}</span>
          </div>
          <div class="tr">
            <span>District</span>
            <span>{{ getAreaName('district', form.addr_district) }}</span>
          </div>
          <div class="tr">
            <span>Area</span>
            <span>{{ getAreaName('area', form.addr_area) }}</span>
          </div>
          <div class="tr">
            <span>Country / Region</span>
            <span>{{ getAreaName('region', form.addr_region) }}</span>
          </div>
        </section>
        <!-- Contractors’ All Risks (C.A.R.) -->
        <section v-if="form.insurance_type === 1601">
          <div class="tr">
            <span>Insured Name </span>
            <span>{{ form.isrd_nm }}</span>
          </div>
          <div class="tr">
            <span>Contract Period</span>
            <span>{{ getGlobalOptionName('contract_period', form.contract_period) }}</span>
          </div>
          <div class="tr">
            <span>Total Contract Value</span>
            <span>HK$ {{ form.total_contract_vl | formatMoney }}</span>
          </div>
          <div class="tr">
            <span>Material Damage</span>
            <span>{{ getOptionName('yesNo2Options', form.material_damage_ind) | formatYesNo }}</span>
          </div>
          <div class="tr">
            <span>Third Party Liability</span>
            <span>{{ getGlobalOptionName('third_party_liability', form.third_party_liability) }}</span>
            <!-- <span>{{ form.third_party_liability | formatMoney }} HKD</span> -->
          </div>
          <div class="tr">
            <span>Scaffolding Work</span>
            <span>{{ getOptionName('yesNo2Options', form.scaffold_ind) | formatYesNo }}</span>
          </div>
          <!--          <div class="tr">-->
          <!--            <span>Contract Value</span>-->
          <!--            <span>{{ form.contract_vl | formatMoney }} HKD</span>-->
          <!--          </div>-->
          <div class="tr">
            <span>Work at Height</span>
            <span>{{ getGlobalOptionName('work_at_height', form.work_at_height) }}</span>
            <!-- <span>{{ form.work_at_height == 99? form.work_at_height_other: getGlobalOptionName('work_at_height', form.work_at_height) }}</span> -->
          </div>
          <div class="tr">
            <span>Outdoor Work</span>
            <span>{{ getOptionName('yesNo2Options', form.outdoor_ind) | formatYesNo }}</span>
          </div>
          <div
            v-if="form.outdoor_ind == 1"
            class="tr">
            <span>Contract Sum of Out Door Work</span>
            <span>HK$ {{ form.outdoor_vl | formatMoney }}</span>
          </div>
          <div class="tr">
            <span>Employees' Compensation</span>
            <span>{{ getOptionName('yesNo2Options', form.compensation_ind) | formatYesNo }}</span>
          </div>
          <div class="tr">
            <span>Please provide Scope of Work & Contract Breakdown</span>
            <span
              class="blue pointer "
              @click="openFile(form.photos.url? form.photos.url: null)"
            >
              {{ form.photos.id? form.photos.client_name: '-' }}
              <div
                v-if="form.photos.url"
                class="upload-card">
                <img
                  :src="form.photos.url"
                  alt="" />
              </div>
            </span>
          </div>
        </section>
        <!-- Employee Benefits (E.B.) -->
        <section v-if="form.insurance_type >= 1200 && form.insurance_type < 1300">
          <div class="tr">
            <span>Insured Name </span>
            <span>{{ form.isrd_nm }}</span>
          </div>
          <div class="tr">
            <span>Effective Date </span>
            <span>{{ form.eff_dt }}</span>
          </div>
          <div class="tr">
            <span>Business Nature </span>
            <span>
              {{ getGlobalOptionName('industry', form.business) }}
            </span>
          </div>
          <div class="tr">
            <span>No. of Employee(s)</span>
            <span>{{ form.no_of_employee }} Person</span>
          </div>
          <section v-show="form.insurance_type === 1202">
            <div class="tr">
              <span>Manual work involved?</span>
              <span>{{ getOptionName('yesNo2Options', form.manual_ind) | formatYesNo }}</span>
            </div>
            <div class="tr">
              <span>Stationed overseas?</span>
              <span>{{ getOptionName('yesNo2Options', form.oversea_ind) | formatYesNo }}</span>
            </div>
          </section>
          <section v-show="form.insurance_type !== 1203">
            <div class="tr">
              <span>Have you made or reported claim in the last 3 years?</span>
              <span>{{ getOptionName('yesNo2Options', form.claim_ind) | formatYesNo }}</span>
            </div>
          </section>
          <section v-show="form.insurance_type === 1203">
            <div class="tr">
              <span>No. of Spouse(s)</span>
              <span>{{ form.no_of_spouse }} Person</span>
            </div>
            <div class="tr">
              <span>No. of Kid(s)</span>
              <span>{{ form.no_of_kid }} Person</span>
            </div>
            <div class="tr">
              <span>No. of Member(s) Over Age 64</span>
              <span>{{ form.no_of_older }} Person</span>
            </div>
            <div class="tr">
              <span>Have you made or reported a claim in the last 3 years (At least for the past 9 months)?</span>
              <span>{{ getOptionName('yesNo2Options', form.claim_ind) | formatYesNo }}</span>
            </div>
          </section>
          <div class="tr">
            <span>Do you have any existing policy schedule(s)?</span>
            <span>{{ getOptionName('yesNo2Options', form.pcy_sch_ind) | formatYesNo }}</span>
          </div>
        </section>
        <!-- Public Liability -->
        <section v-if="form.insurance_type === 1301">
          <div class="tr">
            <span>Insured Name </span>
            <span>{{ form.isrd_nm }}</span>
          </div>
          <div class="tr">
            <span>Effective Date </span>
            <span>{{ form.eff_dt }}</span>
          </div>
          <div class="tr">
            <span>Business Nature </span>
            <span>{{ getGlobalOptionName('industry', form.business) }}</span>
          </div>
          <div class="tr">
            <span>Limit of Liability</span>
            <span>{{ getGlobalOptionName('limit_of_liability', form.limit_of_liability) }}</span>
          </div>
          <div class="tr">
            <span>Have you made or reported claim in the last 3 years?</span>
            <span>{{ getOptionName('yesNo2Options', form.claim_ind) | formatYesNo }}</span>
          </div>
          <div class="tr">
            <span>Do you have any existing policy schedule(s)?</span>
            <span>{{ getOptionName('yesNo2Options', form.pcy_sch_ind) | formatYesNo }}</span>
          </div>
          <span class="address-label">Insured Premises Address</span>
          <div class="tr">
            <span>Room</span>
            <span>{{ form.addr_room }}</span>
          </div>
          <div class="tr">
            <span>Floor</span>
            <span>{{ form.addr_floor }}</span>
          </div>
          <div class="tr">
            <span>Block</span>
            <span>{{ form.addr_block }}</span>
          </div>
          <div class="tr">
            <span>Building / Estate</span>
            <span>{{ form.addr_building }}</span>
          </div>
          <div class="tr">
            <span>Street</span>
            <span>{{ form.addr_street }}</span>
          </div>
          <div class="tr">
            <span>District</span>
            <span>{{ getAreaName('district', form.addr_district) }}</span>
          </div>
          <div class="tr">
            <span>Area</span>
            <span>{{ getAreaName('area', form.addr_area) }}</span>
          </div>
          <div class="tr">
            <span>Country / Region</span>
            <span>{{ getAreaName('region', form.addr_region) }}</span>
          </div>
        </section>
        <!-- Property -->
        <section v-if="form.insurance_type === 1401">
          <div class="tr">
            <span>Insured Name </span>
            <span>{{ form.isrd_nm }}</span>
          </div>
          <div class="tr">
            <span>Effective Date </span>
            <span>{{ form.eff_dt }}</span>
          </div>
          <div class="tr">
            <span>Business Nature </span>
            <span>{{ getGlobalOptionName('industry', form.business) }}</span>
          </div>
          <div class="tr">
            <span>Sum Insured - Building </span>
            <span>HK$ {{ form.sum_building | formatMoney }}</span>
          </div>
          <div class="tr">
            <span>Sum Insured - Contents </span>
            <span>HK$ {{ form.sum_content | formatMoney }}</span>
          </div>
          <div class="tr">
            <span>Sum Insured - Stock</span>
            <span>HK$ {{ form.sum_stock | formatMoney }}</span>
          </div>
          <div class="tr">
            <span>Sum Insured - Machinery/Tools of Trade</span>
            <Span>HK$ {{ form.sum_mt | formatMoney }} </Span>
          </div>
          <div class="tr">
            <span>Have you made or reported claim in the last 3 years?</span>
            <div class="cloumn-box">
              <span>{{ getOptionName('yesNo2Options', form.claim_ind) | formatYesNo }}</span>
              <img
                :src="form.photos.url"
                alt="">
            </div>
          </div>
          <div class="tr">
            <span>Do you have any existing policy schedule(s)?</span>
            <span>{{ getOptionName('yesNo2Options', form.pcy_sch_ind) | formatYesNo }}</span>
          </div>
          <span class="address-label">Insured Premises Address</span>
          <div class="tr">
            <span>Room</span>
            <span>{{ form.addr_room }}</span>
          </div>
          <div class="tr">
            <span>Floor</span>
            <span>{{ form.addr_floor }}</span>
          </div>
          <div class="tr">
            <span>Block</span>
            <span>{{ form.addr_block }}</span>
          </div>
          <div class="tr">
            <span>Building / Estate</span>
            <span>{{ form.addr_building }}</span>
          </div>
          <div class="tr">
            <span>Street</span>
            <span>{{ form.addr_street }}</span>
          </div>
          <div class="tr">
            <span>District</span>
            <span>{{ getAreaName('district', form.addr_district) }}</span>
          </div>
          <div class="tr">
            <span>Area</span>
            <span>{{ getAreaName('area', form.addr_area) }}</span>
          </div>
          <div class="tr">
            <span>Country / Region</span>
            <span>{{ getAreaName('region', form.addr_region) }}</span>
          </div>
        </section>
        <!-- Marine Cargo -->
        <section v-if="form.insurance_type === 1701">
          <div class="tr">
            <span>Insured Name </span>
            <span>{{ form.isrd_nm }}</span>
          </div>
          <div class="tr">
            <span>Interest / Goods to be insured</span>
            <span>{{ form.goods }}</span>
          </div>
          <div class="tr">
            <span>Packing</span>
            <span>{{ form.packing }}</span>
          </div>
          <div class="tr">
            <span>From</span>
            <span>{{ form.from }}</span>
          </div>
          <div class="tr">
            <span>To</span>
            <span>{{ form.to }}</span>
          </div>
          <div class="tr">
            <span>Via</span>
            <span>{{ form.via }}</span>
          </div>
          <!-- <div class="tr">
              <span>Voyage / Transit</span>
              <v-input v-model="formData.via" />
            </div> -->
          <div class="tr">
            <span>Conveyance</span>
            <span>{{ getGlobalOptionName('conveyance', form.conveyance) }}</span>
          </div>
          <div class="tr">
            <span>Currency</span>
            <span>{{ form.currency }}</span>
          </div>
          <div class="tr">
            <span>Basis of Valuation (Invoice Value)</span>
            <span>{{ form.valuation }}</span>
          </div>
          <div class="tr">
            <span>Terms of cover required</span>
            <span>{{ getGlobalOptionName('terms_of_cover_required', form.trm_of_cvr) }}</span>
          </div>
          <div class="tr">
            <span>Additional Conditions</span>
            <span>{{ form.additional_conditions}}</span>
          </div>
        </section>
        <!-- Other -->
        <section v-if="form.insurance_type === 9000">
          <div class="tr">
            <span>Insured Name </span>
            <span>{{ form.isrd_nm }}</span>
          </div>
          <div class="tr">
            <span>Insurance Type</span>
            <span>
              <span
                v-for="(item, index) in form.other_insurance_type"
                :key="index"
                class="block">
                {{ getOptionName('ticketOptions.insuranceTypeOptions', item) }}
              </span>
            </span>
            <!-- <v-checkbox-group
              v-model="formData.other_insurance_type"
              :block="true"
              :list="ticketOptions.insuranceTypeOptions" /> -->
          </div>
          <div class="tr">
            <span>Message</span>
            <span>{{ form.message }}</span>
          </div>
        </section>
        <!-- Motors Fleet / Motor Trade -->
        <section v-if="form.insurance_type >= 1500 && form.insurance_type < 1600">
          <section v-if="form.insurance_type === 1501">
            <div class="tr">
              <span>Type of insured</span>
              <span>Motors Fleet</span>
            </div>
            <div class="tr">
              <span>Name of insured</span>
              <span>{{ form.isrd_nm }}</span>
            </div>
            <div class="tr">
              <span>Business Nature </span>
              <span>{{ getGlobalOptionName('industry', form.isrd_bo) }}</span>
            </div>
            <div class="tr">
              <span>Vehicle Type</span>
              <span>{{ getGlobalOptionName('vehicle_type', form.vehicle_type) }}</span>
            </div>
          </section>

          <section v-if="form.insurance_type === 1502">
            <div class="tr">
              <span>Type of insured</span>
              <span>Motor Trade</span>
            </div>
            <div class="tr">
              <span>Number of driver(s)</span>
              <span>{{ form.no_of_nm_drvr }}</span>
              <!-- <v-radio-group
                v-model="formData.no_of_nm_drvr"
                :border="true"
                :list="numberFourOptions" /> -->
            </div>
            <div class="tr">
              <span>Business / Occupation</span>
              <span>{{ getGlobalOptionName('industry', form.isrd_bo) }}</span>
            </div>
          </section>
        </section>
      </div>
      <section v-if="form.insurance_type === 1502">
        <h2>Insured Driver(s)</h2>
        <drivers-info-motor :form="form.nm_drvr_list" />
      </section>

    </template>
    <template v-else-if="type === 3">
      <h2>Request Detail</h2>
      <div class="table strip">
        <div class="tr th">
          <span >Item</span>
          <span class="bold">Information</span>
        </div>
        <!-- <div class="tr">
          <span>Effective Date</span>
          <span></span>
        </div> -->
        <div class="tr">
          <span>Contact Number</span>
          <span>{{ form.contact_no }}</span>
        </div>
        <!--        <div class="tr">-->
        <!--          <span>Preferred Time for Call-back</span>-->
        <!--          <span>{{ getGlobalOptionName('call_back_preferred_time', form.preferred_time) }}</span>-->
        <!--        </div>-->
        <!-- <div class="tr">
          <span>Action</span>
          <span>{{ form.action_language }}</span>
        </div> -->
      </div>
      <h2>Endorsement Type</h2>
      <div class="table strip">
        <div class="tr th">
          <span>Endorsement Type</span>
          <span class="bold">Information</span>
        </div>
        <div class="tr">
          <span>Action</span>
          <span>{{ form.action_language }}</span>
        </div>
      </div>
      <!-- <template v-if="form.action === 1">
        <h2>Endorsement Type</h2>
        <div class="table strip">
          <div class="tr th">
            <span>Endorsement Type</span>
            <span>Information</span>
          </div>
          <div class="tr">
            <span>Insurance History And Claim Record</span>
            <span>{{ getOptionName('yesNo2Options', form.insurance_claim_ind) | formatYesNo }}</span>
          </div>
          <div class="tr">
            <span>Change Policyholder Information</span>
            <span>{{ getOptionName('yesNo2Options', form.change_policy_holder_ind) | formatYesNo }}</span>
          </div>
          <div class="tr">
            <span>Change Driver Information</span>
            <span>{{ getOptionName('yesNo2Options', form.change_driver_ind) | formatYesNo }}</span>
          </div>
          <div class="tr">
            <span>Change Car Detail</span>
            <span>{{ getOptionName('yesNo2Options', form.change_car_ind) | formatYesNo }}</span>
          </div>
          <div class="tr">
            <span>Other</span>
            <span>{{ getOptionName('yesNo2Options', form.other_ind) | formatYesNo }}</span>
          </div>
        </div>
      </template> -->
      <h2>Message</h2>
      <p v-if="form.message">{{ form.message }}</p>
      <span v-else>No Message</span>
      <!-- 文件 -->
      <file-container
        v-for="(item, index) in form.other_file"
        :key="index"
        :fileData="item" />
    </template>
    <template v-else-if="type === 4">
      <h2>Request Detail</h2>
      <div class="table">
        <div class="tr">
          <span>Type</span>
          <span>Credit Card</span>
        </div>
      </div>
      <div class="table strip">
        <div class="tr">
          <span>Transfer Type</span>
          <span>{{ getOptionName('cashout_list',form.type) }}</span>
        </div>
        <div class="tr">
          <span>Transfer Amount</span>
          <span>{{ form.money }}</span>
        </div>
        <div class="tr">
          <span>Cardholder Name</span>
          <span>{{ form.card_holder }}</span>
        </div>
        <div class="tr">
          <span>Issuing Bank</span>
          <span>{{ form.card_bank }}</span>
        </div>
        <div class="tr">
          <span>Credit Card Number</span>
          <span>{{ form.card_number }}</span>
        </div>
      </div>
    </template>
    <template v-else-if="type === 7">
      <h2>Request Detail</h2>
      <div class="table strip">
        <div class="tr th">
          <span>Item</span>
          <span class="bold">Information</span>
        </div>
        <div class="tr">
          <span>Client Name</span>
          <span>{{ form.name }}</span>
        </div>
        <div class="tr">
          <span>Client Contact Number</span>
          <span
            :class="{
              'blue': form.is_registered
            }">
            {{ form.phone }}
            <span
              v-if="form.is_registered"
              class="span-status status-blue">Registered</span>
            <span
              v-else
              class="span-status">Not Registered</span>
          </span>
        </div>
        <!-- <div class="tr">
          <span>Contact Number</span>
          <span>test</span>
        </div> -->
        <div class="tr">
          <span>Product Type</span>
          <span>{{ form.product_language }}</span>
        </div>
        <div class="tr">
          <span>Your Nickname </span>
          <span>{{ form.nick_name }}</span>
        </div>
        <div class="tr">
          <span>Remark</span>
          <span>{{ form.remark }}</span>
        </div>
        <!-- <div class="tr">
          <span>Supporting Doc. </span>
          <span class="blue pointer">paper.pdf</span>
        </div> -->
        <div
          v-for="(item, index) in form.other_file"
          :key="index"
          class="tr">
          <span>Supporting Doc. </span>
          <span
            class="blue pointer"
            @click="openFile(item.url)">{{ item.client_name }}</span>
        </div>
      </div>

    </template>
    <template v-else>
      <h2>Request Detail</h2>
      <div class="table strip">
        <div class="tr th">
          <span>Item</span>
          <span class="bold">Information</span>
        </div>
        <div class="tr">
          <span>Accident Date</span>
          <span>{{ form.accident_date }}</span>
        </div>
        <div class="tr">
          <span>Contact Person</span>
          <span>{{ form.contact_person }}</span>
        </div>
        <div class="tr">
          <span>Contact Number</span>
          <span>{{ form.contact_no }}</span>
        </div>
        <div class="tr">
          <span>Brief Description Of The Accident</span>
          <span class="pre_wrap">{{ form.description }}</span>
        </div>
        <!-- <div class="tr">
          <span>Claim Form</span>
          <span>{{form.claim_form? 'claimform.pdf': '-' }}</span>
        </div> -->
        <div
          v-for="(item, index) in form.other_file"
          :key="index"
          class="tr">
          <span>Documents</span>
          <span
            class="blue pointer"
            @click="openFile(item.url)">{{ item.client_name }}</span>
        </div>
        <div
          v-if="!form.other_file"
          class="tr">
          <span>Documents</span>
          <span>-</span>
        </div>
      </div>
    </template>
  </section>
</template>

<script>
import MixinFormat from '@/mixins/format'
import MixinOptions from '@/mixins/options'
import WorkingQuoteInfo from '@/views/components/modules/working/working-quote-info'
import StudentQuoteInfo from '@/views/components/modules/student/student-quote-info'
import DriversInfo from '@/views/tickets/components/info/drivers-info'
import InsuredVehicleInfo from '@/views/components/insured-vehicle-info'
import PolicyHolderInfo from '@/views/tickets/components/info/policy-holder-info'
import HousemaidQuoteInfo from '@/views/components/modules/housemaid/housemaid-quote-info'
import DecorationQuoteInfo from '@/views/components/modules/decoration/decoration-quote-info'
import HomefireQuoteInfo from '@/views/components/modules/homefire/homefire-quote-info'
import fireQuoteInfo from '@/views/components/modules/homefire/fire-quote-info'
import quickQuoteInfo from '@/views/components/quick-quote-info'
import travelQuoteInfo from '@/views/components/modules/travel/travel-quote-info'
import PersonalQuoteInfo from '@/views/components/modules/personal/personal-quote-info'

export default {
  name: 'ticket-detail',
  components: {
    WorkingQuoteInfo,
    StudentQuoteInfo,
    // BaseInfo,
    DriversInfo,
    InsuredVehicleInfo,
    PolicyHolderInfo,
    HousemaidQuoteInfo,
    DecorationQuoteInfo,
    HomefireQuoteInfo,
    fireQuoteInfo,
    quickQuoteInfo,
    travelQuoteInfo,
    PersonalQuoteInfo,

  },
  mixins: [MixinFormat, MixinOptions],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    inter: {
      type: Boolean,
      default: false  //  控制是否顯示内部文件
    },
    customer: {
      type: [Object,Array],
      default: () => ({})
    },
    type:{
      type: Number,
      default: 0
    },
  },
  computed: {
    isIndustry() {
      return [
        2001, 2101, 2201, 2301, 2401, 2501, 2601, 2701
      ].includes(this.form.insurance_type)
    },
    productId() {
      return this.form.product_id
    },
    classId() {
      return this.form.classId || 14
    },
    localAllOptions() {
      if(this.classId === 14) {
        return this.allOptions
      } else {
        return this[`allOptions${this.classId}`]
      }
    },
    mortgagorOption() {
      // 拿status 為1的數據
      let { mortgagor=[] } = this.localAllOptions
      if(mortgagor.length) {
        mortgagor = mortgagor.filter(e=>e.status)
      }
      return mortgagor
    },
    isMortgagorOther(){
      let {mortgagor}=this.form
      let list = this.mortgagorOption.filter(item=>{
        return item.id==mortgagor
      })
      return list.length>0&&list[0].is_other==1?true:false
    },
    benefits() {
      if(!this.localAllOptions || !this.localAllOptions.benefits || !this.form.benefits) {
        return []
      }
      return this.localAllOptions.benefits.filter(item => {
        return this.formData.benefits.includes(item.id)
      })
    },
    extraBenefitSelect(){
      let {extra_benefits_content={}} = this.form
      let arr =[]
      if(extra_benefits_content){
        arr = Object.entries(extra_benefits_content).map(item=>item[1])
      }
      return arr||[]
    },
    insuranceType() {
      const { insurance_type } = this.form
      let type = insurance_type
      if(type > 1500 && type <= 1599) {
        type = 1500
      }
      if(type > 1200 && type < 1299) {
        type = 1200
      }
      const { allTypeOptions } = this.ticketOptions
      const list = [
        ...allTypeOptions,
        ...this.industryTypeOptions
      ]


      return this.getOptionName('', type, list)
    },
    // claimOtherFile() {
    //   let result = []
    //   for(let i = 1; i <= 6; i++) {
    //     if(this.form[`other_file_${i}`]) {
    //       result.push(this.form[`other_file_${i}`])
    //     }
    //   }
    //   return result
    // }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        this.formData = JSON.parse(JSON.stringify(val))
        let {upload_document = {}} = val
        let {br_files = []} = upload_document
        this.formData.br_files_type_pic = br_files[0]

        if (this.productId == 80) {
          let {upload_document = {}} = val
          let {br_files = []} = upload_document
          this.formData.upload_document = upload_document
          this.formData.br_files_type_pic = br_files[0]
        }
      }
    },
    specialOptions:{
      immediate: true,
      deep: true,
      handler(val){
        if(val.marketing_data){
          let arr = JSON.parse(JSON.stringify(val.marketing_data)) || []
          this.marketingList = arr
        }
      }
    },
  },
}
</script>

<style scoped>

</style>
